import { api } from '../config/api';

export const companyService = {
  // Obtener todas las empresas
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.skip) queryParams.append('skip', params.skip);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);

    const queryString = queryParams.toString();
    const endpoint = `/companies/${queryString ? `?${queryString}` : ''}`;
    return await api.get(endpoint);
  },

  // Obtener una empresa por ID
  getById: async (id) => {
    return await api.get(`/companies/${id}/`);
  },

  // Crear una empresa
  create: async (companyData) => {
    return await api.post('/companies/', companyData);
  },

  // Actualizar una empresa
  update: async (id, companyData) => {
    return await api.put(`/companies/${id}/`, companyData);
  },

  // Eliminar una empresa
  delete: async (id) => {
    return await api.delete(`/companies/${id}/`);
  }
};
